import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { VariantCtaContainer, VariantCtaText } from './VariantCta.styles';

function VariantCta(props) {
  // checkForLimitedQuantity(product)
  const [isAvailable, setIsAvailable] = useState(true);
  const [isSelected, setIsSelected] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(props?.returnIsVariantVisible(props?.variantName, props?.rowIndex));
    setIsAvailable(props?.returnIsVariantAvailable(props?.variantName, props?.rowIndex));
  }, [
    props?.variantName,
    props?.rowIndex,
    props?.outOfVisbleInfo,
    props?.toggleClick,
    props?.outOfStockInfo,
  ]);

  useEffect(() => {
    if (props?.variantName === props?.activeVariantOption) {
      setIsSelected(true);
    } else setIsSelected(false);
  }, [props?.activeVariantOption, props?.toggleClick]);

  const clickHandler = () => {
    props?.handleVariantBtnClick(props?.rowIndex, props?.variantName, isVisible);
  };

  const getTrimmedVariantName = (variantName) => {
    if (variantName.length > 20) {
      return `${variantName.slice(0, 20)}...`;
    }
    return variantName;
  };

  if (!isVisible) {
    return null;
  }

  return (
    <>
      <VariantCtaContainer
        isAvailable={isAvailable}
        isSelected={isSelected}
        variantName={props?.variantName}
        onClick={clickHandler}
        storeInfo={props.storeInfo}
      >
        <VariantCtaText
          storeInfo={props.storeInfo}
          isSelected={isSelected}
          isAvailable={isAvailable}
        >
          {getTrimmedVariantName(props?.variantName)}
        </VariantCtaText>
      </VariantCtaContainer>
    </>
  );
}

export default VariantCta;
